import { render } from "./DepartmentManage.vue?vue&type=template&id=aac38fdc"
import script from "./DepartmentManage.vue?vue&type=script&lang=js"
export * from "./DepartmentManage.vue?vue&type=script&lang=js"

import "./DepartmentManage.vue?vue&type=style&index=0&id=aac38fdc&lang=less"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__